import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserStore } from '../../store/user/useUserStore';
import { selectUser } from '../../store/user/userSelectors';

interface IProps {
  children: React.ReactNode;
}

/**
 * Frontend-only convenience guard: the authoritative check is the backend
 * `admin`-only right on each protected endpoint. This only spares a non-admin
 * from seeing the page shell after a direct URL visit.
 */
const AdminRouteGuard = ({ children }: IProps) => {
  const user = useUserStore(selectUser);

  if (user?.role !== 'admin') {
    return <Navigate to="/lead" replace />;
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
